import { Cell } from "@/types/cell"
import { Level } from "@/types/facility"
import { CardSize, Token } from "@/types/index"
import { LevelConfigurationItemMode } from "@/types/levelConfiguration"

export const UNKNOWN_LOCATION_ID = "unknown-location"

export type Location = Omit<
   Level,
   "alertConfigurations" | "vacant" | "maintenance"
>

export const getVirtualChildLocations = (
   levels: Location[] | undefined,
   parentLevelId: string | undefined
): Location[] => {
   if (!parentLevelId) return []
   return (levels ?? []).filter(
      (level) =>
         level.parents?.includes(parentLevelId) &&
         level.type.mode === LevelConfigurationItemMode.VIRTUAL
   )
}

export const getOccupiedCellsCount = (cells: Cell[]) => {
   const occupiedCells = cells.filter((cell) => !cell.vacant).length
   const totalCells = cells.length
   return { occupiedCells, totalCells }
}

export const gridSettings = {
   small: {
      display: "grid",
      gridAutoFlow: "dense",
      gridTemplateColumns: "repeat(auto-fill, 2.083vw)",
      gridAutoRows: "minmax(2.083vw, min-content)",
   },
   default: {
      display: "grid",
      gridAutoFlow: "dense",
      gridTemplateColumns: "repeat(36, minmax(0, 1fr))",
      gridAutoRows: "minmax(2.083vw, min-content)",
      columnGap: "0.625vw",
      rowGap: "0.417vw",
   },
}

export const getPersistedCollapsedLocationIds = (): string[] => {
   try {
      const stored = localStorage.getItem(Token.COLLAPSED_LOCATIONS)
      return stored ? JSON.parse(stored) : []
   } catch {
      return []
   }
}

export const persistCollapsedLocationIds = (locationIds: string[]) => {
   localStorage.setItem(Token.COLLAPSED_LOCATIONS, JSON.stringify(locationIds))
}

const wearablePlaceholderClassName: Record<CardSize, string> = {
   [CardSize.LARGE]: "floor-overview__wearable-placeholder--large",
   [CardSize.MEDIUM]: "floor-overview__wearable-placeholder--medium",
   [CardSize.SMALL]: "",
}

export const getWearableCardSize = (): CardSize =>
   (localStorage.getItem(Token.SMARTWATCH_CARD_SIZE) as CardSize) ??
   CardSize.MEDIUM

export const getWearableCardPlaceholderClassName = (
   size: CardSize,
   hasActiveAlert: boolean
): string => {
   if (hasActiveAlert) return "floor-overview__wearable-placeholder--large"
   return wearablePlaceholderClassName[size]
}
